/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class PurchaseProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      Providers: [],
      comboProvides: [],
      printInfo: [],
      lengthProviders: 0,
      grouping: '',
      getGrouping: '',
      providerArr: [],
      providers: [],
      finalStocks: [],
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بارکد محصول',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ آخرین فروش',
          value: 'lastPurchaseDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مدت زمان عدم فروش',
          value: 'lastPurchaseDayCount',
          sorted: false,
          direction: null,
          sortable: true
        }
      ]
    }
  }

  componentDidMount() {
    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then(response => {
    //     if (response.data.error == null) {
    //       var provider = response.data.object;
    //       for (let i = 0; i < provider.length; i++) {
    //         provider[i]["value"] = provider[i].providerId;
    //         provider[i]["label"] =
    //           provider[i].providerId + " - " + provider[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object
    //       });
    //     } else {
    //       this.setState({
    //         providers: []
    //       });
    //     }
    //   });
    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }
  getPurchaseProvider = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_PROVIDER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            Providers: response.data.object.result,
            min: lastPurchaseDayCountMin,
            max: lastPurchaseDayCountMax,
            lengthProviders: response.data.object.countAll,
            buttonClicked: true,
            getGrouping: this.state.grouping,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            Providers: [],
            lengthProviders: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getPurchaseProvider(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getPurchaseProvider(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getPurchaseProvider(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      Providers: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Providers: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let {providerArr, finalStocks, providerId} = this.state
    var lastPurchaseDayCountMin = document.getElementById('lastPurchaseDayCountMin').value.trim()
    var lastPurchaseDayCountMax = document.getElementById('lastPurchaseDayCountMax').value.trim()
    var productGrouping = document.getElementById('productGrouping').value
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (finalStocks.length !== '') {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (productGrouping !== '' && productGrouping.length) {
      filter.productGrouping = productGrouping
    }
    if (lastPurchaseDayCountMin !== '') {
      filter.lastPurchaseDayCountMin = lastPurchaseDayCountMin.trim()
    }
    if (lastPurchaseDayCountMax !== '') {
      filter.lastPurchaseDayCountMax = lastPurchaseDayCountMax.trim()
    }
    if (providerId) {
      filter.providerIds = providerId
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getPurchaseProvider(false)
        }
      )
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_PROVIDER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['lastPurchaseDate'] = jMoment(excelReport[i]['lastPurchaseDate']).format('jYY/jMM/jDD HH:mm')
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_PROVIDER}`, {
        params: filter
      })
      .then((response) => {
        console.log(response)

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
          // message.error(response.data.description)
        }
      })
      // alert(JSON.stringify(response.data))
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  changeGrouping = (e) => {
    let target = e.target
    this.setState({
      grouping: target.options[target.selectedIndex].text
    })
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let excelColumns = [
      {title: 'نام تامین کننده', value: 'title'},
      {title: 'شناسه تامین کننده', value: 'providerId'},
      {title: 'کد ملی', value: 'nationalId'},
      {title: 'کد اقتصادی', value: 'economicCode'}
    ]
    let name = cookie.load('name')
    let columns =
      this.state.getGrouping === 'محصول'
        ? [
            'ردیف',
            'نام تامین کننده',
            'نام محصول',
            'کد محصول',
            'بارکد محصول',
            'تاریخ آخرین فروش',
            'مدت زمان عدم فروش(روز)'
          ]
        : ['ردیف', 'نام تامین کننده', 'تاریخ آخرین فروش', 'مدت زمان عدم فروش(روز)']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش عدم فروش تامین کنندگان"
              headerColSpan={this.state.getGrouping === 'محصول' ? '7' : '4'}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={this.state.getGrouping === 'محصول' ? '3' : '2'}
              rightColSpan={this.state.getGrouping === 'محصول' ? '3' : '1'}
              centerColSpan={1}
              centerSection={''}
              rightSection={
                ' تعداد روز از : ' + this.state.min + ' تا : ' + this.state.max + ' برمبنای : ' + this.state.getGrouping
              }
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((providers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{providers.providerName}</td>
                  {this.state.getGrouping === 'محصول' && (
                    <>
                      <td>{providers.product.productName}</td>
                      <td>{providers.product.articleId}</td>
                      <td>{providers.product.productCode}</td>
                    </>
                  )}
                  <td>{jMoment(providers.lastPurchaseDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{providers.lastPurchaseDayCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش عدم فروش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              {this.state.getGrouping === 'محصول' && (
                <gridColumn
                  key={'productName'}
                  field={'product.productName'}
                  title={'نام محصول'}
                  width="200px"
                  footerCellOptions={{wrap: true, textAlign: 'center'}}
                />
              )}

              {this.state.getGrouping === 'محصول' && (
                <gridColumn
                  key={'articleId'}
                  field={'product.articleId'}
                  title={'کد محصول'}
                  width="200px"
                  footerCellOptions={{wrap: true, textAlign: 'center'}}
                />
              )}

              {this.state.getGrouping === 'محصول' && (
                <gridColumn
                  key={'productCode'}
                  field={'product.productCode'}
                  title={'بارکد محصول'}
                  width="200px"
                  footerCellOptions={{wrap: true, textAlign: 'center'}}
                />
              )}

              <gridColumn
                key={'economicCode'}
                field={'lastPurchaseDate'}
                title={'تاریخ آخرین فروش'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'economicCode'}
                field={'lastPurchaseDayCount'}
                title={'مدت زمان آخرین فروش(روز)'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>عدم فروش تامین کنندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/report/purchase/provider'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>حداقل روز</label>
                  <input type="text" className="form-control" id="lastPurchaseDayCountMin" />
                </div>
                <div className="formComponent">
                  <label>حداکثر روز</label>
                  <input type="text" className="form-control" id="lastPurchaseDayCountMax" />
                </div>

                <div className="formComponent">
                  <label>بر مبنای </label>
                  <select className="form-control" onChange={this.changeGrouping} id="productGrouping">
                    <option value={''}>------</option>
                    <option value={true}>محصول</option>
                    <option value={false}>تامین کننده</option>
                  </select>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                  <Select
                    value={this.state.multiProvider}
                    onChange={this.handleChangeProvider}
                    options={this.state.providers}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  /> */}
                </div>
              </div>
              <div>
                <SearchProduct getStocks={this.getStocks} finalStocks={this.finalStocks} />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.Providers.map((providers, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{providers.providerName}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: providers.product.articleId})}>
                          {providers.product.productName}
                        </a>
                      </td>
                      <td>{providers.product.articleId}</td>
                      <td>{providers.product.productCode}</td>
                      <td>{jMoment(providers.lastPurchaseDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{providers.lastPurchaseDayCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProviders}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PurchaseProvider
